export default __webpack_public_path__ + "static/media/chartUp.be34f2cd.svg";